module.exports = __webpack_public_path__ + "static/media/first-aid-training.911e7be5.svg";